{
  "fallback": {
    "400": "Some information is not valid — check what you entered",
    "401": "Please sign in again",
    "403": "You do not have permission to do this",
    "404": "This could not be found — it may have been deleted",
    "409": "This clashes with another change — reload and try again",
    "410": "This has expired",
    "413": "This is too large",
    "422": "Some information is missing or not valid",
    "423": "This is locked for now — try again later",
    "428": "Reload the latest version before saving",
    "429": "Too many tries — wait a moment and try again",
    "5xx": "Something went wrong on our side — try again in a moment",
    "network": "Cannot reach the shop system — check the internet connection",
    "unknown": "Something went wrong"
  },
  "field": {
    "required": "{{label}}: please fill this in",
    "must_be_positive": "{{label}} must be more than 0",
    "greater_than": "{{label}} must be more than {{limit}}",
    "greater_than_equal": "{{label}} must be at least {{limit}}",
    "less_than": "{{label}} must be less than {{limit}}",
    "less_than_equal": "{{label}} must be at most {{limit}}",
    "too_short": "{{label}} is too short",
    "too_long": "{{label}} is too long",
    "too_long_limit": "{{label}} is too long (at most {{limit}})",
    "pattern": "{{label}}: the format is not right",
    "whole_number": "{{label}} must be a whole number",
    "number": "{{label}} must be a number",
    "choice": "{{label}}: choose one of the options",
    "email": "{{label}}: this is not an e-mail address",
    "date": "{{label}}: this is not a valid date",
    "invalid": "{{label}} is not valid"
  },
  "hints": {
    "status": {
      "401": "Sign in again — what you typed is kept as a draft.",
      "403": "Ask the shop owner to give your account this permission.",
      "409": "Reload to see the latest data, then do it again.",
      "422": "Fix the fields marked in red, then save again.",
      "429": "Wait about a minute, then try again.",
      "5xx": "Try again in a minute. If it keeps happening, copy the reference code and send it to the owner.",
      "network": "Check Wi-Fi or mobile data. Forms with drafts are saved when you are back online."
    },
    "codes": {
      "version_conflict": "Load the latest version to see what changed, or keep yours and save over it.",
      "insufficient_stock": "Check stock on the item page — it may have sold in the shop or online.",
      "oversell_conflict": "Open the double-sale screen and choose who keeps the card.",
      "tax_evidence_missing": "Open the order and add the export proof (shipping label or customs form).",
      "raw_rank_required": "Choose the rank A, B, C or D for this card.",
      "price_below_cost": "Check the price — it is lower than what you paid.",
      "reason_required": "Write a short reason, e.g. \"damaged\" or \"count correction\".",
      "account_locked": "Wait for the time shown, or ask the owner to unlock your account.",
      "issuer_registration_missing": "Settings → Tax: enter the shop's T-number.",
      "order_not_paid": "Press ① 入金確認 first when the money has arrived.",
      "identity_check_required": "Do the identity check (本人確認) for this person first.",
      "payment_has_funds": "Confirm the payment first, then give the money back with a refund.",
      "manager_approval_required": "Ask a manager to approve on this screen.",
      "manager_pin_required": "Ask a manager to enter their PIN.",
      "taxfree_training_required": "Ask the owner — only trained staff can do tax-free sales."
    }
  },
  "codes": {
    "validation_failed": "Some information is missing or not valid — check the highlighted fields",
    "invalid_reference": "Something this refers to no longer exists — reload and choose again",
    "invalid_cursor": "This list page is out of date — go back to the first page",
    "unauthorized": "Please sign in again",
    "token_expired": "Your sign-in has expired — please sign in again",
    "forbidden": "You do not have permission to do this",
    "not_found": "This could not be found — it may have been deleted",
    "method_not_allowed": "This action is not possible here",
    "conflict": "This clashes with another change — reload and try again",
    "version_conflict": "Someone else changed this before you",
    "idempotency_key_required": "The request could not be sent safely — try again",
    "if_match_required": "Reload the latest version before saving",
    "idempotency_conflict": "This was already sent with different details — reload and check",
    "payload_too_large": "This is too large to send — make it smaller",
    "rate_limited": "Too many tries in a short time — wait a moment and try again",
    "feature_disabled": "This feature is not enabled",
    "invalid_state_transition": "This action is not allowed in the current state",
    "upstream_unavailable": "Part of the system is not answering right now — try again shortly",
    "internal_error": "Something went wrong on our side",
    "insufficient_stock": "This item is no longer available",
    "unit_not_available": "This card is no longer available",
    "hold_not_found": "Reservation not found",
    "hold_expired": "Reservation has expired",
    "oversell_conflict": "This card was sold on another channel",
    "location_not_allowed": "You are not allowed to work at this location",
    "hold_not_active": "This reservation is no longer active",
    "unit_already_sold": "This card has already been sold",
    "reason_required": "A reason is required for this change",
    "location_inactive": "This location is not active",
    "location_has_stock": "This location still holds stock",
    "location_is_default": "The default location cannot be deactivated",
    "hold_type_not_allowed": "This kind of reservation is not allowed for a one-of-a-kind card",
    "hold_extension_limit": "This reservation cannot be extended any further",
    "use_unit_action": "One-of-a-kind cards are adjusted per card, not by quantity",
    "not_consigned": "This card does not belong to a consignor",
    "unit_on_hold": "This card is reserved — release the hold before moving it",
    "stream_capacity_reached": "Too many live connections right now — retry shortly",
    "conflict_not_open": "This conflict has already been resolved",
    "unit_already_in_show": "This card is already in a live show",
    "raw_rank_missing": "This card has no rank yet — set its rank (A/B/C/D) before printing a label",
    "discrepancy_not_open": "This stock difference was already handled",
    "discrepancy_manual_fix": "This stock difference has to be fixed card by card — see the suggested action",
    "sale_not_voidable": "This sale can no longer be voided — take the goods back as a return",
    "return_exceeds_sale": "More would come back than this sale took",
    "raw_rank_required": "Raw cards must have a rank (A/B/C/D)",
    "handle_recently_used": "This web address was used recently — choose another one",
    "compare_at_evidence_missing": "The \"was\" price needs proof (8 weeks of sales or the maker's price)",
    "duplicate_set": "A set with this code and language already exists",
    "duplicate_card": "This card already exists in the set",
    "in_use": "This record is still used by products",
    "not_enabled": "This feature is not enabled",
    "unknown_attribute": "Unknown attribute",
    "invalid_attribute": "Attribute value is invalid",
    "category_cycle": "A category cannot be its own ancestor",
    "category_too_deep": "Categories can be nested at most 3 levels",
    "graded_fields_required": "Graded cards need grading company, grade and certificate number",
    "condition_type_mismatch": "Condition type does not match the product type",
    "invalid_grade": "Grade must be between 1 and 10 in steps of 0.5",
    "invalid_raw_rank": "Rank must be one of A, B, C, D",
    "invalid_cert_format": "Certificate number does not look like this grader's format",
    "price_below_cost": "Price is below cost",
    "legacy_condition_alias_rejected": "Use the shop rank A/B/C/D instead of NM/LP/MP/HP/DMG",
    "weight_required": "Weight is required for sealed products",
    "duplicate_sku": "This item code is already used",
    "invalid_ean": "Barcode is not a valid JAN/EAN-13 number",
    "reserved_handle": "This web address is reserved — choose another one",
    "compare_at_type_not_allowed": "This kind of compare-at evidence is not allowed for this product type",
    "export_price_low": "Export price is far below the tax-exclusive shop price",
    "channel_not_enabled": "This sales channel is not enabled yet",
    "last_variant": "A product needs at least one version (condition/price)",
    "variant_in_use": "This version still has stock or sales — archive the product instead",
    "too_many_variants": "Too many versions in one save — save in smaller parts",
    "restore_window_expired": "This product was deleted more than 30 days ago and cannot be restored",
    "duplicate_cert": "A card with this certificate number is already listed",
    "duplicate_barcode": "This barcode is already used by another item",
    "similar_product_exists": "A product for the same card and condition already exists",
    "too_many_media": "A product can have at most 10 images",
    "media_not_in_product": "Pick the picture from this product's own pictures",
    "media_failed": "An image could not be processed",
    "no_media": "The product has no image yet",
    "publish_blocked": "The product cannot be published yet — fix the items in the checklist",
    "invalid_rule": "A condition of this automatic collection is not valid",
    "collection_is_smart": "Products of an automatic collection come from its conditions",
    "file_too_large": "The file is too large",
    "unknown_columns": "The file has columns this import does not know",
    "missing_columns": "The file is missing required columns",
    "too_many_rows": "The file has too many rows",
    "invalid_file_encoding": "The file could not be read — save it as CSV UTF-8",
    "import_has_errors": "Some rows have errors — fix them or choose to skip them",
    "unknown_csv_profile": "The kind of file could not be recognised — start from the sample file",
    "currency_not_jpy": "Prices in this file must be Japanese yen — confirm the currency",
    "export_not_ready": "The export file is still being prepared",
    "export_expired": "This export file has expired — export again",
    "variant_not_found": "No item matches this code",
    "unsupported_media_type": "This kind of file is not accepted — use JPEG, PNG, WebP, HEIC, GIF or PDF",
    "upload_quota_exceeded": "The daily upload limit is reached — try again tomorrow",
    "upload_not_received": "The file has not arrived yet — upload it again",
    "restricted_upload_required": "ID documents and transfer slips go through the secure upload",
    "purpose_not_allowed": "This kind of file cannot be uploaded here",
    "upload_session_not_open": "This photo session is closed — start a new one on the computer",
    "upload_session_full": "This photo session is full",
    "handoff_token_invalid": "This QR code has expired — show a new one on the computer",
    "media_restore_expired": "This file was deleted too long ago and cannot be restored",
    "storage_unavailable": "File storage cannot be reached right now — try again shortly",
    "restricted_link_invalid": "This viewing link has expired or was already used — open the file again",
    "retention_shorten_forbidden": "The keep-until date of this file can only be moved later, never earlier",
    "document_data_inconsistent": "The amounts of this document do not add up — it was not issued",
    "document_type_not_supported": "This kind of document cannot be created yet",
    "document_already_superseded": "This document was already replaced by a corrected version — use the latest one",
    "document_render_failed": "The document could not be created right now — it will be tried again",
    "recipient_name_required": "A full invoice needs the name of the buyer (宛名)",
    "issuer_registration_missing": "The shop's invoice registration number (登録番号) is not set yet",
    "customs_data_incomplete": "Enter the weight, HS code and value of every item before printing",
    "document_issuer_incomplete": "The shop's name and address for documents are not set up yet",
    "document_source_unsupported": "This document cannot be made for this record — send the document data",
    "order_not_payable": "This order cannot be paid",
    "payment_method_unavailable": "Payment method is not available",
    "payment_already_captured": "Payment was already captured",
    "amount_mismatch": "Amount does not match",
    "cart_not_found": "No shopping bag was found — start a new one",
    "cart_line_not_found": "This item is not in the bag",
    "cart_line_limit": "The bag is full — remove an item first",
    "product_unavailable": "This item cannot be bought online",
    "discount_not_found": "This discount code does not exist",
    "discount_expired": "This discount code has expired",
    "discount_not_started": "This discount code is not valid yet",
    "discount_usage_exhausted": "This discount code has been used up",
    "discount_min_subtotal": "The bag total is below the minimum for this code",
    "discount_channel": "This discount code is not valid here",
    "discount_no_eligible_lines": "No item in the bag can use this discount code",
    "shipping_unavailable": "We cannot ship to this address",
    "too_heavy": "The parcel is too heavy for our shipping methods",
    "address_required": "A delivery address is needed first",
    "shipping_rate_invalid": "This shipping rate is not valid",
    "shipping_zone_conflict": "A country or prefecture is already in another shipping zone",
    "ddp_required": "Shipping to the United States must be DDP (duties paid by the shop)",
    "pickup_location_invalid": "This location does not offer store pickup",
    "postal_code_not_found": "This postal code was not found",
    "inventory_unavailable": "Stock cannot be checked right now",
    "catalog_unavailable": "Product details cannot be loaded right now",
    "tax_unavailable": "Taxes cannot be calculated right now",
    "secondhand_license_required": "Buying cards and taking cards on consignment are closed until the shop's 古物商許可 (公安委員会 and permit number) is saved in Settings → Shop details.",
    "web_orders_paused": "Web orders are paused right now (Settings → Checkout). The shop counter is not affected.",
    "discount_type_not_supported": "This kind of discount is not available yet",
    "cart_empty": "The bag is empty — add an item first",
    "checkout_not_found": "This checkout was not found",
    "checkout_expired": "The time to finish this order has run out — please start again from the bag",
    "checkout_already_placed": "This order has already been placed",
    "checkout_incomplete": "Some details are still missing before the order can be placed",
    "totals_changed": "The total has changed — please check the new amount and confirm again",
    "return_policy_ack_required": "Please confirm that you have read the return policy",
    "tokusho_ack_required": "Please confirm the order details (特定商取引法に基づく表示)",
    "ddp_notice_ack_required": "Please confirm the import duty notice for this destination",
    "payment_method_invalid": "This way of paying cannot be used for this order — choose another one",
    "payments_unavailable": "Payments cannot be prepared right now",
    "identity_unavailable": "Customer details cannot be saved right now",
    "order_not_found": "This order was not found",
    "order_number_format_locked": "The order number format cannot change once orders exist",
    "order_not_pending_payment": "This order is not waiting for a payment any more",
    "method_mismatch": "This order is not paid by bank transfer — nothing to report here",
    "payment_not_found": "This payment was not found for the order",
    "nothing_to_resolve": "There is no difference in the payment left to settle",
    "order_not_paid": "The order is not paid yet — confirm the payment first",
    "order_under_review": "A manager has to approve this order before it is prepared",
    "invalid_transition": "This step cannot be done at this point",
    "undo_window_passed": "It is too late to undo this step — a manager can do it with a note",
    "insurance_required": "High-value parcels need full insurance and a signature on delivery",
    "fulfillment_not_found": "This shipment was not found",
    "order_not_shipped": "Nothing of this order has been sent yet",
    "tracking_edit_window_passed": "The tracking number can only be corrected within 24 hours of shipping",
    "pickup_qr_invalid": "This pickup code is not valid for any order",
    "carrier_unknown": "Unknown delivery company",
    "tracking_format_invalid": "This tracking number does not match the delivery company's format",
    "tracking_url_invalid": "The tracking link must be the delivery company's own page",
    "zonos_declaration_required": "Parcels to the United States need the Zonos declaration ID (duties prepaid)",
    "declared_value_mismatch": "The customs value must be the real sale price of the item",
    "order_not_editable": "This order can no longer be changed",
    "order_line_not_found": "This item is not part of the order",
    "use_return_flow": "The goods were already sent — use a return instead of cancelling",
    "order_already_cancelled": "This order was already cancelled",
    "final_sale": "Cards are final sale — they come back only when damaged, wrong or not as described",
    "return_window_passed": "The time to return this item has passed",
    "return_not_allowed": "This item cannot be returned for this reason",
    "return_not_found": "This return was not found",
    "return_already_open": "A return is already open for this item",
    "return_invalid_state": "This step cannot be done for this return now",
    "document_already_issued": "This document was already issued — correct it from the documents screen",
    "provider_disabled": "This way of paying is not switched on yet",
    "payment_not_pending": "This payment is no longer waiting for money",
    "method_not_allowed_for_channel": "This way of paying cannot be used here",
    "refund_exceeds_captured": "The refund is larger than what was paid and not yet refunded",
    "store_credit_insufficient": "Not enough store credit",
    "store_credit_expiry_exceeds_policy": "Store credit may be valid for at most 6 months",
    "customer_required": "A customer account is needed for this",
    "surcharge_disabled_by_default": "Charging card fees to customers may break card-network or terminal contract rules — check with your card provider and confirm before turning it on",
    "brand_not_supported": "This card terminal does not take this brand",
    "payment_method_in_use": "Payments are still waiting on this method — finish or cancel them first",
    "insufficient_tender": "The cash received is less than the amount",
    "edc_duplicate_approval": "This card approval was already recorded today",
    "four_eyes_required": "Another manager has to approve what you requested",
    "refund_method_not_allowed": "The money cannot be given back this way for this payment",
    "payment_has_funds": "Money for this payment already arrived — confirm it and give it back with a refund instead of cancelling",
    "tax_evidence_missing": "Export evidence is missing",
    "tax_free_not_eligible": "Not eligible for tax-free purchase",
    "tax_free_threshold_not_met": "Tax-free minimum amount not reached",
    "discount_exceeds_total": "Discount is larger than the discountable total",
    "discount_line_unknown": "Discount references a line that is not in the document",
    "taxfree_web_not_allowed": "Tax-free sales are only possible at the counter",
    "taxfree_mixed_receipt": "Tax-free receipt contains ineligible lines — split the receipt",
    "taxfree_detail_required": "High-value tax-free items need item details and a serial",
    "taxfree_not_licensed": "The shop has no tax-free shop licence",
    "commission_outside_settlement": "Commission lines belong to settlement documents only",
    "calculation_not_found": "No stored tax calculation for this document",
    "invalid_registration_number": "Registration number must be T followed by 13 digits",
    "field_locked": "This setting is locked and cannot be changed here",
    "wari2_ended": "The 2割特例 ended with the tax period containing 2026-09-30",
    "wari3_not_allowed": "The 3割特例 is only for individual businesses in 2027–2028",
    "simplified_taxation_dates_required": "簡易課税 needs a from/to period",
    "effective_from_too_early": "Effective date must be today (no documents yet) or later",
    "rounding_change_period_boundary": "Rounding changes take effect from the next tax period",
    "append_only": "Settings versions are append-only — create a new version",
    "settings_version_not_found": "Tax settings version not found",
    "legal_calendar_event_not_found": "Legal calendar event not found",
    "source_url_required": "A source URL is required when changing a legal date",
    "market_not_found": "Market not found",
    "market_exists": "A market with this code already exists",
    "market_country_conflict": "A country can belong to only one market",
    "market_protected": "This market cannot be removed or deactivated",
    "fx_rate_not_found": "Exchange rate not found",
    "fx_rate_unavailable": "No exchange rate is available for this currency",
    "mrz_invalid": "The passport could not be read — scan the two lines at the bottom again",
    "verification_not_found": "Tax-free verification not found",
    "verification_expired": "Tax-free verification has expired — scan the passport again",
    "verification_consumed": "This tax-free verification was already used for a receipt",
    "calc_mismatch": "Amounts do not match the stored tax calculation of this document",
    "already_confirmed": "Customs already confirmed this record — it cannot be changed",
    "taxfree_record_not_found": "Tax-free record not found",
    "taxfree_record_cancelled": "This tax-free record is cancelled",
    "export_batch_not_found": "Export batch not found",
    "export_batch_empty": "No tax-free records to export for this period",
    "transmission_not_retryable": "This transmission is not in a state that can be retried",
    "already_final": "The customs result of this tax-free record was already recorded",
    "customs_not_applicable": "This tax-free record does not wait for a customs confirmation",
    "nta_api_not_enabled": "The NTA connection is not enabled yet — import the customs results as a file",
    "customs_import_invalid": "The customs result file could not be read",
    "taxfree_refund_not_allowed": "The tax refund cannot be requested for this record right now",
    "export_evidence_not_found": "No export evidence for this order",
    "evidence_item_not_found": "Evidence item not found",
    "evidence_locked": "Evidence can only be removed within 24 hours — it is now kept for 7 years",
    "evidence_not_required": "This order no longer needs export evidence",
    "tax_document_not_found": "No tax snapshot exists for this document",
    "document_type_not_applicable": "This document type cannot be issued for this sale or refund",
    "report_range_invalid": "The report period is not valid",
    "taxfree_training_required": "Only staff trained for tax-free sales can do this",
    "calculation_locked": "This tax calculation already backs an issued document and cannot change",
    "customs_after_deadline": "The customs check is after the 90-day deadline — the sale stays taxable",
    "taxfree_payload_invalid": "The purchase record does not fit the tax-free submission layout",
    "consignor_not_linked": "No consignor account is linked",
    "identity_check_required": "Identity verification is required",
    "consignor_suspended": "This consignor account is paused — please contact the shop",
    "consignor_not_active": "The consignor is not active yet — finish the identity check first",
    "consignor_close_blocked": "The consignor still has cards or money with the shop — settle them first",
    "bank_account_required": "Payment by bank transfer needs a bank account",
    "bank_account_invalid": "The bank account details are not valid",
    "customer_already_linked": "This customer account already belongs to another consignor",
    "payout_in_progress": "A payment to this consignor is being processed — try again when it is finished",
    "agreement_locked": "This agreement version is already in use — publish a new version instead",
    "agreement_already_accepted": "The consignor has already accepted this agreement version",
    "invalid_tiers": "Commission price ranges must start at ¥0, have no gaps or overlaps, and end open",
    "blocked_minor": "Customers under 18 cannot sell or consign without a guardian's written consent",
    "method_not_allowed_for_remote": "This way of checking identity is only allowed face to face",
    "method_not_allowed_for_face_to_face": "This way of checking identity is only for mail-in or online transactions",
    "method_not_allowed_for_foreign_national": "For foreign nationals, check a residence card or a passport",
    "identity_document_expired": "The ID document has expired",
    "identity_check_not_pending": "This identity check was already verified or rejected",
    "manager_approval_required": "A manager has to approve this",
    "document_not_attachable": "This file cannot be used as an ID document image — upload it again",
    "tax_free_item_check_required": "Confirm the cards were not bought tax-free (免税) before recording the purchase",
    "counterparty_address_required": "The seller's address is required for the 古物台帳",
    "shogaku_tokurei_not_available": "The small-amount special rule does not apply to this purchase",
    "kobutsu_entries_exist": "This transaction is already recorded in the 古物台帳",
    "kobutsu_correction_invalid": "This correction cannot be recorded — check the corrected fields",
    "agreement_not_accepted": "The consignor has to accept the latest consignment agreement first",
    "intake_not_editable": "This intake is already completed or cancelled and cannot be changed",
    "intake_empty": "Add at least one card before completing the intake",
    "invalid_stage_transition": "The card cannot be moved to this status from where it is now",
    "proposal_pending": "A price change for this card is already waiting for an answer",
    "proposal_not_pending": "This price change was already answered",
    "discount_not_editable": "The discount permission cannot be changed for this card any more",
    "settlement_locked": "Money was already paid for this sale — use an adjustment instead",
    "payout_not_processing": "This payment was already marked as paid or cancelled",
    "payout_nothing_due": "There is nothing to pay to this consignor now",
    "payout_below_minimum": "The amount is below the minimum payment — it waits for the next payment",
    "payout_allocation_invalid": "The payment does not match what is still owed for these sales",
    "payout_proof_required": "Record the proof of payment (transfer reference or the consignor's signature)",
    "store_credit_customer_required": "Store credit needs the consignor's customer account — link it first",
    "statement_not_ready": "The statement is still being prepared — please try again in a moment",
    "item_reserved": "Someone is buying this card right now — it cannot be returned at the moment",
    "item_not_returnable": "This card cannot be returned from where it is now",
    "return_not_editable": "This return is already finished or cancelled",
    "customer_not_authenticated": "Please sign in to see your consigned items",
    "read_only_impersonation": "You are viewing as the consignor — changes are not allowed",
    "portal_action_required": "This change can only be made from the consignor portal",
    "consignor_consent_required": "This needs the consignor's agreement first",
    "verification_required": "Enter the code we sent to your e-mail to confirm this change",
    "verification_code_invalid": "The code is not correct or has expired",
    "human_check_required": "Please confirm you are not a robot",
    "human_check_failed": "The robot check failed — please try again",
    "manager_pin_required": "A manager PIN is required",
    "shift_not_open": "No open shift on this register",
    "register_mismatch": "Register does not match the device",
    "event_schema_invalid": "Something went wrong on our side",
    "manifest_invalid": "The list of page parts sent by the storefront build is not valid",
    "manifest_version_mismatch": "The version of the page-part list does not match its content",
    "manifest_not_found": "The storefront has not sent its list of page parts yet",
    "manifest_missing": "The website cannot be checked yet — the storefront has not sent its page parts",
    "theme_not_found": "Theme not found",
    "theme_version_not_found": "This published version does not exist",
    "theme_is_live": "The theme shown on the website cannot be archived or deleted — publish another first",
    "theme_archived": "This theme is archived — restore it first",
    "theme_incompatible": "Some parts of the website need fixing before it can be published",
    "theme_not_published": "No theme has been published yet",
    "template_not_found": "This page layout does not exist",
    "template_exists": "This page layout already exists",
    "template_is_base": "The main layout of a page type cannot be deleted",
    "template_invalid": "The page layout has problems — see the list",
    "section_group_invalid": "The header/footer area has problems — see the list",
    "policy_required": "Legal pages required by law are not complete in Japanese and English yet",
    "force_not_allowed": "Only the owner can publish while legal pages are incomplete",
    "preview_expired": "This preview link has expired",
    "preview_invalid": "This preview link is not valid",
    "preview_token_not_found": "Preview link not found",
    "handle_taken": "This web address is already used by another page",
    "page_not_found": "This page does not exist",
    "page_trashed": "This page is in the trash — restore it first",
    "policy_incomplete": "Some required items of this legal page are empty in Japanese or English",
    "policy_not_published": "This legal page has not been published yet",
    "policy_version_not_found": "This version of the legal page does not exist",
    "menu_not_found": "This menu does not exist",
    "menu_item_not_found": "This menu link does not exist",
    "menu_depth_exceeded": "Menus can only be 3 levels deep",
    "menu_too_large": "A menu can have at most 200 links",
    "menu_cycle": "A menu link cannot be placed inside itself",
    "menu_in_use": "The website still shows this menu — remove it from the page layout first",
    "redirect_not_found": "No redirect for this web address",
    "redirect_exists": "A redirect for this web address already exists",
    "redirect_invalid": "This redirect is not valid",
    "redirect_loop": "This redirect would send visitors in a circle",
    "redirect_chain_too_long": "Too many redirects in a row — point the old address straight at the final page",
    "announcement_not_found": "This announcement does not exist",
    "announcement_limit_exceeded": "Too many announcements would be shown at the same time — end or turn one off first",
    "locale_not_found": "This language is not set up in the shop",
    "locale_disabled": "This language is not offered on the website",
    "locale_required": "English and the default language of the website cannot be turned off",
    "ui_string_not_found": "This website text does not exist",
    "ui_string_core": "Built-in website texts cannot be deleted — change the wording instead",
    "placeholder_mismatch": "The translation uses a {placeholder} that the English text does not have",
    "icu_syntax_invalid": "The text has a mistake in its {…} part — check the braces",
    "translation_invalid": "Some translations could not be saved — nothing was changed, see the list",
    "translator_not_configured": "Automatic translation is not set up — type the translation or ask the owner",
    "media_item_not_found": "This file is not in the media library",
    "media_in_use": "The website still uses this file — replace it in these places first",
    "media_folder_not_found": "This folder does not exist",
    "media_folder_not_empty": "This folder still has folders inside — move or delete them first",
    "media_tag_not_found": "This tag does not exist",
    "media_name_taken": "A folder or tag with this name already exists",
    "revalidation_not_found": "This website refresh does not exist",
    "revalidation_in_progress": "This website refresh is being sent right now — wait a moment",
    "unsupported_format": "This file is not a theme backup this system can read",
    "theme_import_invalid": "The theme file is damaged — see the list of problems",
    "invalid_credentials": "E-mail or password is incorrect",
    "account_locked": "Too many failed attempts — try again later",
    "mfa_code_invalid": "The verification code is incorrect",
    "password_too_weak": "Password does not meet the policy",
    "pin_too_weak": "PIN must be 4–6 digits and not a common sequence",
    "challenge_token_invalid": "This link or code is invalid or has expired",
    "email_already_exists": "A user with this e-mail already exists",
    "role_in_use": "This role is still assigned to staff",
    "system_role_protected": "System roles cannot be changed or deleted",
    "last_owner_protected": "This would leave the shop without an active owner",
    "unknown_permission": "Unknown permission",
    "pairing_code_invalid": "Pairing code is invalid, used or expired",
    "device_revoked": "This device is no longer paired with the register",
    "pin_invalid": "PIN is incorrect",
    "otp_code_invalid": "The code is incorrect or has expired",
    "csrf_token_invalid": "Your sign-in could not be confirmed — reload the page and try again",
    "address_invalid": "Address is not valid",
    "too_many_addresses": "The address book is full",
    "customer_merge_invalid": "These customers cannot be merged",
    "export_too_large": "Too many rows for one export; narrow the date range or filters",
    "webhook_url_invalid": "This notification address is not allowed"
  }
}
